<template>
  <div id="pageContent">
    <div class="find-page">
      <div class="top">
        <img src="@/assets/img/dragons_text.png" alt="">
        <p class="title">아이디 찾기</p>
        <p class="sub">{{subText}}</p>
      </div>

      <!-- 1. 본인인증 -->
      <div v-if="order === 1" class="user-citation">
        <Citation @authComplete="authComplete" :type="certType"/>
      </div>
      <!-- 2. 아이디 확인 -->
      <div v-if="order === 2" class="input-div">
        <input type="text" class="input-style readonly" v-model="loginId" disabled>
        <router-link :to="{name: 'login'}">
          <button class="login-btn">로그인</button>
        </router-link>
      </div>

    </div>
  </div>
</template>

<script>
import Citation from '@/components/Common/Citation.vue';

export default {
  name: 'FindId',
  components: {Citation},
  data() {
    return {
      certType: 'findid',
      subText: '아이디 찾기를 위해서는 본인인증이 필요합니다',
      order: 1,
      loginId: '',
    }
  },
  mounted () {
  },
  watch: {
    order: {
      handler: function () {
        switch (this.order) {
          case 2 :
            this.subText = '아이디 찾기 결과입니다.';
            break;
          default :
            break;
        }
      }
    }
  },
  methods: {
    async authComplete(certType, certInfo) {
      const obj = {
        ci: certInfo.ci,
        di: certInfo.di,
        realcheck_idx: certInfo.realcheck_idx
      };
      const {data} = await this.$http.post('/account/id', obj);

      if(data.success) {
        this.loginId = data.user_id;
        this.order = 2;
      } else {
        alert(data.message);
        this.order = 1;
      }
    },
  }
}
</script>
